<template>
    <div class="app-container">
      <BjRouteTabs :route-list="ORDER_ABNORMAL_FIVE_ROUTE_LIST" />
      <BjPage ref="BjPage"
        :query-params="queryParams"
        :get-action="queryApi"
        :radio="radio"
        :before-reset-search="beforeResetSearch"
        :tooltip-config="{ showAll: false, enterable: false }"
        :selection="selection"
        :search-btn-hide="true"
        @handleSelectionChange="handleSelectionChange"
        @showSetting="SortableTable.show"
        @header-dragend="SortableTable.handleHeaderDragend"
        @header-contextmenu="SortableTable.handleHeaderContextmenu"
      >
        <!-- <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('businessLogisticsCompanyList.status')" prop="logisticsStatus">
              <BjSelectLov v-model="queryParams.logisticsStatus" :placeholder="$t('businessLogisticsCompanyList.status')" :option-list="ORDER_INTERNAL_HUNT_STATUS_LIST" />
            </el-form-item>
          </el-col>
        </template> -->
        <template v-slot:tableOperation>
          <el-col>
            <!-- <el-button type="primary" class="main-btn" @click="batchSendEmail">{{ $t('businessLogisticsCompanyList.batchEmail') }}</el-button> -->
            <!-- <el-button type="primary" @click="batchOrderOver">{{ $t('businessLogisticsCompanyList.batchDone') }}</el-button> -->
          </el-col>
        </template>
        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'outerOrderNo'">
                  <span>{{ scope.row.outerOrderNo }}</span>
                  <BjCopyIcon :copy="scope.row.outerOrderNo" />
                </template>
                <template v-else-if="col.prop === 'innerOrderNo'">
                  <span>{{ scope.row.innerOrderNo }}</span>
                  <BjCopyIcon :copy="scope.row.innerOrderNo" />
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <!-- <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button> -->
                <el-button type="text" class="edit-btn" @click="onCancel(props.row)">{{ $t('businessLogisticsCompanyList.done') }}</el-button>
                <!-- <el-button type="text" class="delete-btn" @click="innerOrderOver(props.row)">{{ $t('businessLogisticsCompanyList.done') }}</el-button> -->
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { orderApi } from '@/api';
  import { ORDER_ABNORMAL_FIVE_ROUTE_LIST,
    ORDER_INTERNAL_HUNT_STATUS_LIST,
  } from '@/utils/constants';
  export default {
    name: 'BusinessAbnormalOrderHUNT',
    components: {},
    mixins: [pageMiXin],
    data() {
      return {
        selection: false,
        colSpan: 4,
        ORDER_ABNORMAL_FIVE_ROUTE_LIST,
        ORDER_INTERNAL_HUNT_STATUS_LIST,
        queryApi: orderApi.getInternalPageHUNTNew,
        // 查询参数
        queryParamsTime_order: [],
        queryParams: {
          // orderNo: null,
          // channel: null,
          // storeIdList: [],
          // cusId: null,

          // orderStatus: '0',
          logisticsStatus: "0",
        },
        labelList: [
          { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: 150 },
          { label: this.$t('OrdinaryOrderMix.LogisticsTable.innerOrderNo'), prop: 'innerOrderNo', isCheck: true, disabled: false, width: 150},
          // { label: this.$t('businessLogisticsCompanyList.status'), prop: 'logisticsStatus', isCheck: true, disabled: false, width: 150},
          { label: this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo'), prop: 'logisticsNo', isCheck: true, disabled: false},
          { label: this.$t('OrdinaryOrderMix.LogisticsTable.logisticsCompany'), prop: 'logisticsCompany', isCheck: true, disabled: false },
          { label: this.$t('OrdinaryOrderMix.LogisticsTable.logisticsBusinessName'), prop: 'logisticsBusinessName', isCheck: true, disabled: false },
          { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
        ],
      };
    },
    methods: {
      // 物流取消按钮 
      onCancel(row) {
        const POST_DATA = {
          innerOrderNo: row.innerOrderNo,
          outerOrderNo: row.outerOrderNo,
          logisticsNo : row.logisticsNo,
        }
        this.$confirm(this.$t('InternalSalesOrderDetails.Operation'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          orderApi.cancelPageHUNTButton(POST_DATA).then(res => {
            console.log(res,'res');
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        }).catch(() => {});
      },
      // 查看
      // onView(row) {
      //   // 内部订单详情页
      //   this.$router.push({
      //     name: 'BusinessOrderInternalViewCSG',
      //     query: { id: '', code: encodeURIComponent(row.innerOrderNo), tabName: 'waitHunter' },
      //   });
      // },
      // 内部订单完结
      // innerOrderOver(row) {
      //   if(row.logisticsStatus == '3'){
      //     return this.$message.warning(this.$t('businessLogisticsCompanyList.ps2'));
      //   }
      //   orderApi.innerOrderOver([row.innerOrderNo]).then(res => {
      //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
      //       this.$message.success(this.$t('toast.operationSuccessText'));
      //       setTimeout(() => {
      //         this.reFresh();
      //       }, 500);
      //     }
      //   });
      // },
      // 批量完结
      // batchOrderOver() {
      //   if (!this.selectedRows.length) {
      //     this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
      //     return;
      //   }
      //   if (this.selectedRows.some(e => e.logisticsStatus == '3')) {
      //     this.$message.warning(this.$t('businessLogisticsCompanyList.ps2'));
      //     return;
      //   }
      //   this.$confirm(this.$t('InternalSalesOrderDetails.Operation'), this.$t('toast.hintText'), {
      //     confirmButtonText: this.$t('toast.okText'),
      //     cancelButtonText: this.$t('toast.cancelText'),
      //     type: 'warning',
      //   }).then(() => {
      //     let innerOrderNos = [];
      //     innerOrderNos = this.selectedRows.map(item => item.innerOrderNo);
      //     orderApi.innerOrderOver(innerOrderNos).then(res => {
      //       if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
      //         this.$message.success(this.$t('toast.operationSuccessText'));
      //         setTimeout(() => {
      //           this.reFresh();
      //         }, 500);
      //       }
      //     });
      //   }).catch(() => {});
      // },
      // 内部订单发邮件
      // orderSendEmail(row) {
      //   orderApi.orderSendEmail([row.innerOrderNo]).then(res => {
      //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
      //       this.$message.success(this.$t('toast.operationSuccessText'));
      //       setTimeout(() => {
      //         this.reFresh();
      //       }, 500);
      //     }
      //   });
      // },
      // 批量发邮件
      // batchSendEmail() {
      //   if (!this.selectedRows.length) {
      //     this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
      //     return;
      //   }
      //   if (this.selectedRows.some(e => e.logisticsBusinessName != 'ALLI' || e.logisticsStatus == '3')) {
      //     this.$message.warning(this.$t('businessLogisticsCompanyList.ps1'));
      //     return;
      //   }
      //   this.$confirm(this.$t('InternalSalesOrderDetails.Operation'), this.$t('toast.hintText'), {
      //     confirmButtonText: this.$t('toast.okText'),
      //     cancelButtonText: this.$t('toast.cancelText'),
      //     type: 'warning',
      //   }).then(() => {
      //     let innerOrderNos = [];
      //     innerOrderNos = this.selectedRows.map(item => item.innerOrderNo);
      //     orderApi.orderSendEmail(innerOrderNos).then(res => {
      //       if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
      //         this.$message.success(this.$t('toast.operationSuccessText'));
      //         setTimeout(() => {
      //           this.reFresh();
      //         }, 500);
      //       }
      //     });
      //   }).catch(() => {});
      // },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParams.cusId = null;
        this.queryParams.logisticsStatus = "9";
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
